/**
 * Store recherchesSauvegardees
 */
export default {
    state: {
        recherchesSauvegardees: []
    },

    mutations: {
        /**
         * Initialise le state rechercheSauvegardee
         */
        setRecherchesSauvegardees: function (state, recherchesSauvegardees) {
            state.recherchesSauvegardees = recherchesSauvegardees
        }
    },

    actions: {
        resetRecherchesSauvegardees: function (context, payload) {
            context.commit('setRecherchesSauvegardees', [])

            return axios.get('/api/recherches-sauvegardees').then(response => {
                context.commit('setRecherchesSauvegardees', response.data.data)
                if (payload) {
                    payload()
                }
            })
        },
    },

    getters: {
        /**
         * Liste d'options de rechercheSauvegardee
         */
        optionsRecherchesSauvegardees: state => {
            return _.sortBy(state.recherchesSauvegardees
                .filter(rechercheSauvegardee => rechercheSauvegardee.emplacement !== 'Echanges')
                .map(rechercheSauvegardee => {
                return {label: rechercheSauvegardee.nom, value: rechercheSauvegardee.id}
            }), 'nom')
        },

        optionsRecherchesSauvegardeesEchange: state => {
            return _.sortBy(state.recherchesSauvegardees
                .filter(rechercheSauvegardee => rechercheSauvegardee.emplacement === 'Echanges')
                .map(rechercheSauvegardee => {
                return {label: rechercheSauvegardee.nom, value: rechercheSauvegardee.id}
            }), 'nom')
        },

        optionsAllRecherchesSauvegardees: state => {
            return state.recherchesSauvegardees
                .map(rechercheSauvegardee => ({
                    value: rechercheSauvegardee.id,
                    label: (rechercheSauvegardee.emplacement ? rechercheSauvegardee.emplacement : 'Dossiers') + ' - ' + rechercheSauvegardee.nom,
                }))
                .sort((a, b) => a.label > b.label ? 1 : -1)
        },

        getRecherchesSauvegardees: state => {
            return state.recherchesSauvegardees
        }
    }
}
